import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Cushion, FlexContainer, Space, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import { getCurrentClubId } from '../../store/clubs/selectors';
import { getLastLoadedPageData } from '../../store/meta-data/selectors';
import { pitcheroDomain } from '../../lib/env';

const SuperUserMenu = ({ clubId, lastLoadedPageData }) =>
  clubId && (
    <Cushion vertical="medium" horizontal="xlarge">
      {lastLoadedPageData && (
        <Cushion vertical="small">
          <FlexContainer justifyContent="space-between" alignItems="center">
            <Space right="medium">
              <Icon name="new-window" size={18} color="notification" />
            </Space>
            <div style={{ flex: 1 }}>
              <Typography preset="subtitle--small" color="black" component="div">
                Page&nbsp;Data:
              </Typography>
              <Typography
                preset="subtitle--small"
                color="notification"
                component="a"
                href={`https://${pitcheroDomain()}/_admin/page-cache/v6/data?page_key=${lastLoadedPageData}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {lastLoadedPageData}
              </Typography>
            </div>
          </FlexContainer>
        </Cushion>
      )}
      <a
        href={`https://${pitcheroDomain()}/admin/club/${clubId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Cushion vertical="small">
          <FlexContainer justifyContent="space-between" alignItems="center">
            <Space right="medium">
              <Icon name="new-window" size={18} color="notification" />
            </Space>
            <Typography preset="subtitle--small" color="notification" style={{ flex: 1 }}>
              Club Admin
            </Typography>
          </FlexContainer>
        </Cushion>
      </a>
      <a
        href={`https://${pitcheroDomain()}/_admin/clubs/club.php?id=${clubId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Cushion vertical="small">
          <FlexContainer justifyContent="space-between" alignItems="center">
            <Space right="medium">
              <Icon name="new-window" size={18} color="notification" />
            </Space>
            <Typography preset="subtitle--small" color="notification" style={{ flex: 1 }}>
              Super Admin
            </Typography>
          </FlexContainer>
        </Cushion>
      </a>
    </Cushion>
  );

SuperUserMenu.defaultProps = {
  clubId: null,
  lastLoadedPageData: null,
};

SuperUserMenu.propTypes = {
  clubId: PropTypes.number,
  lastLoadedPageData: PropTypes.string,
};

const mapStateToProps = (state) => ({
  clubId: getCurrentClubId(state),
  lastLoadedPageData: getLastLoadedPageData(state),
});

export default connect(mapStateToProps)(SuperUserMenu);
